module.exports = __webpack_public_path__ + "media/images/edion/en/discount-80017bd41b9e702bd355feb46a901ac9.png";